import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, BACK_URL, REGISTER_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import Thematicpage from './Thematicpage';
import Schedulepage from './Schedulepage';
import SpeakerPage from './SpeakerPage';
import Press from './Press';
import Presspage from './Presspage';
import Quote from './Quote';
import { fetchDetails } from './Api';

export default function Main() {


    const [about, setabout] = useState()

    useEffect(() => {
        const fetchData = async () => {
            const url = `${API_URL}/about`;
            const data = await fetchDetails(url);
            if (data) {
                setabout(data);
            }
        };
        fetchData();
    }, []);


    return (
        <>
            <main id="tg-main" className="tg-main tg-haslayout">

                <section className="tg-sectionspace tg-haslayout" id="about">
                    <div className="container">
                        <div className="row">
                            <div className="tg-aboutus">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">

                                    <div className="tg-sectionhead tg-textalignleft">
                                        <div className="tg-sectionheading">

                                            <h2>About ICDRI 2023</h2>
                                        </div>
                                        <div className="tg-description">
                                            <div dangerouslySetInnerHTML={{ __html: about }}></div>
                                        </div>
                                        <div className="tg-btnarea">
                                            {/* <Link to="/about">Read More</Link> */}
                                            <Link to="/about" className="tg-btn">Read More</Link>
                                            {/*  <Link to={REGISTER_URL} className="tg-btn" target='_blank'>Register</Link>*/}
                                            {/* <a className="tg-btn" href="#">Register Now</a> */}
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2"></div>
                                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                    <div className="tg-videoarea">
                                        <img src="images/icdri-circle-rotate.png" alt="" className="rotate linear infinite" /><p className="pressdesc"><strong>DELIVERING <font color='#C92730'>DRI SOLUTIONS</font> FOR A RESILIENT WORLD</strong></p>

                                    </div>
                                </div>
                                {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <div className="tg-videoarea">
                                        <figure>
                                            <img src="images/video-placeholder.jpg" alt="" />
                                            <figcaption><a href="https://www.youtube.com/watch?v=cG0UK7eN-z8"
                                                className="tg-btnplay"><img
                                                    src="images/btn-playicon.jpg" alt="" /></a>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>


                {/* first Quotes */}
                <Quote pageid="5" />

                {/* Thematic Focus */}
                <Thematicpage />

                {/* Second Quotes */}
                <Quote pageid="6" />

                {/* Schedule */}
                <Schedulepage />

                {/* Third Quotes */}
                <Quote pageid="7" />

                <SpeakerPage limit="4" />

                {/* Fourth Quotes */}
                <Quote pageid="8" />

                <Presspage limit='3' />

                <section className="tg-haslayout tg-bgsignup">
                    <div className="container">
                        <div className="row">
                            <div className="tg-signupnewsletter">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="tg-signupdetail">
                                        <div className="tg-sectionhead tg-textalignleft">
                                            <div className="tg-sectionheading">
                                                {/* <span>What are you waiting for?</span> */}
                                                <h4 className="head link" style={{ textAlign: 'justify' }}>The International Conference on Disaster Resilient Infrastructure (ICDRI) is the annual conference of <a href="https://cdri.world" target="_blank"><font color='#C92730'>Coalition for Disaster Resilient Infrastructure (CDRI)</font></a> and its partners. It brings together Member Countries, organizations, institutions and infrastructure actors and stakeholders to strengthen the global discourse on disaster and climate resilient infrastructure.   </h4>

                                            </div>
                                            {/* <button type="submit" className="tg-btn">View Details</button> */}
                                        </div>

                                        {/* <form className="tg-formtheme tg-formsingup">
                                            <fieldset>
                                                <div className="form-group tg-inputicon">
                                                    <i className="icon-bullhorn"></i>
                                                    <input type="email" name="email" className="form-control"
                                                        placeholder="Your Email" />
                                                </div>
                                                <button type="submit" className="tg-btn">Signup Now</button>
                                            </fieldset>
                                        </form> */}
                                    </div>
                                </div>
                                {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 hidden-sm hidden-xs">
                                    <figure className="tg-newsletterimg"><img src="images/bg-signup.png"
                                        alt="" /></figure>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>
            </main >



        </>
    )
}
